import { AppMode } from '@customTypes/Generic'
import { CreationEvent } from 'src/lib'
import { useConfig } from '@context/ConfigurationContext'
import queryString from 'query-string'

export const useCreationEvent = () => {
  const { mode } = useConfig()
  const params = queryString.parse(window.location.search)

  return mode === AppMode.RECALL
    ? CreationEvent.RECALL
    : (params.creationEvent as string) || CreationEvent.NOT_SPECIFIED
}
